import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";
import {FILTER_ALL} from ".";

interface Props {
	tagList: {code: string; name: string}[];
	handleTagCheck: (checked: boolean, value: string) => void;
	dataStr: string;
}

const PromotionComponent = ({tagList, handleTagCheck, dataStr}: Props) => {
	const promotionListData = dataStr.replaceAll("|", "").split("^");
	const promotionList: {code: string; name: string}[] = [];
	for (let i = 0; i < promotionListData.length; i += 2) {
		const code = promotionListData[i];
		const name = promotionListData[i + 1];
		promotionList.push({code, name});
	}

	return (
		<style.CheckList>
			<style.CheckListItem>
				<input
					type="checkbox"
					id="promotionALL"
					onChange={e => handleTagCheck(e.target.checked, e.target.value)}
					checked={!tagList.length}
					value={JSON.stringify({code: FILTER_ALL, name: "전체"})}
				/>
				<label htmlFor="promotionALL">
					<span>전체</span>
				</label>
			</style.CheckListItem>
			{promotionList.map((promotion, idx) => (
				<style.CheckListItem key={idx}>
					<input
						type="checkbox"
						id={`promotion${promotion.code}`}
						onChange={e => handleTagCheck(e.target.checked, e.target.value)}
						checked={tagList.some(e => e.code === promotion.code)}
						value={JSON.stringify({...promotion})}
					/>
					<label htmlFor={`promotion${promotion.code}`}>
						<span>{promotion.name}</span>
					</label>
				</style.CheckListItem>
			))}
		</style.CheckList>
	);
};

const Promotion = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter Promotion Error">
		<PromotionComponent {...props} />
	</ErrorBoundary>
);

export default Promotion;
